export const getLocationsUrl = () => '/business/locations';

export const getLocationUrl = (id: string = ':id') => `/business/locations/${id}`;
